export const REVIEW_MANAGE_GRID_COLUMN_ID = {
  EMPLOYEE: 'EMPLOYEE',
  RELATIONSHIP: 'RELATIONSHIP',
  REVIEW_STATUS: 'REVIEW_STATUS',
  GRID_POSITION: 'GRID_POSITION',
  OUTCOME: 'OUTCOME',
  OVERALL_RATING: 'OVERALL_RATING',
  OVERALL_NUMERIC_RATING: 'OVERALL_NUMERIC_RATING',
  GOAL_RATING: 'GOAL_RATING',
  GOAL_NUMERIC_RATING: 'GOAL_NUMERIC_RATING',
  COMPETENCY_RATING: 'COMPETENCY_RATING',
  COMPETENCY_NUMERIC_RATING: 'COMPETENCY_NUMERIC_RATING',
  QNA_RATING: 'QNA_RATING',
  QNA_NUMERIC_RATING: 'QNA_NUMERIC_RATING',
  SELF_REVIEW_STATUS: 'SELF_REVIEW_STATUS',
  SELF_OVERALL_RATING: 'SELF_OVERALL_RATING',
  SELF_GOAL_RATING: 'SELF_GOAL_RATING',
  SELF_COMPETENCY_RATING: 'SELF_COMPETENCY_RATING',
  SELF_QNA_RATING: 'SELF_QNA_RATING',
  DLM_NOMINATED: 'DLM_NOMINATED',
  DLM_REVIEW_STATUS: 'DLM_REVIEW_STATUS',
  DLM_OVERALL_RATING: 'DLM_OVERALL_RATING',
  DLM_GOAL_RATING: 'DLM_GOAL_RATING',
  DLM_COMPETENCY_RATING: 'DLM_COMPETENCY_RATING',
  DLM_QNA_RATING: 'DLM_QNA_RATING',
  UPWARD_REVIEW_STATUS: 'UPWARD_REVIEW_STATUS',
  UPWARD_OVERALL_RATING: 'UPWARD_OVERALL_RATING',
  PEER_NOMINATED: 'PEER_NOMINATED',
  PEER_REVIEW_STATUS: 'PEER_REVIEW_STATUS',
  PEER_OVERALL_RATING: 'PEER_OVERALL_RATING',
  MANAGER_REVIEW_STATUS: 'MANAGER_REVIEW_STATUS',
  MANAGER_COMPETENCY_NUMERIC_RATING: 'MANAGER_COMPETENCY_NUMERIC_RATING',
  MANAGER_COMPETENCY_RATING: 'MANAGER_COMPETENCY_RATING',
  MANAGER_GOAL_NUMERIC_RATING: 'MANAGER_GOAL_NUMERIC_RATING',
  MANAGER_GOAL_RATING: 'MANAGER_GOAL_RATING',
  MANAGER_OUTCOME: 'MANAGER_OUTCOME',
  MANAGER_OVERALL_NUMERIC_RATING: 'MANAGER_OVERALL_NUMERIC_RATING',
  MANAGER_OVERALL_RATING: 'MANAGER_OVERALL_RATING',
  MANAGER_QNA_NUMERIC_RATING: 'MANAGER_QNA_NUMERIC_RATING',
  MANAGER_QNA_RATING: 'MANAGER_QNA_RATING',
  EMAIL: 'EMAIL',
  MANAGER_EMAIL: 'MANAGER_EMAIL',
  GENDER: 'GENDER',
  LOCATION: 'LOCATION',
  FUNCTION: 'FUNCTION',
  EXTERNAL_EMP_ID: 'EXTERNAL_EMP_ID',
  ETHNICITY: 'ETHNICITY',
  DATE_OF_JOINING: 'DATE_OF_JOINING',
  DOB: 'DOB',
  COUNTRY: 'COUNTRY',
  DESIGNATION: 'DESIGNATION',
  ROLE: 'ROLE',
  MANAGER: 'MANAGER',
  GRADE: 'GRADE',
  DEPARTMENT: 'DEPARTMENT',
  CALIBRATION_STATUS: 'CALIBRATION_STATUS',
  LAST_COMMENT: 'LAST_COMMENT',
  COMPANY: 'COMPANY',
  SUPER_POD: 'SUPER_POD',
  POD: 'POD',
  IDENTIFIED_FOR_CALIBRATION: 'IDENTIFIED_FOR_CALIBRATION',
};

export const REVIEWS_MANAGE_PAGE_DEFAULT_COLUMN_ORDER = [
  REVIEW_MANAGE_GRID_COLUMN_ID.EMPLOYEE,
  REVIEW_MANAGE_GRID_COLUMN_ID.RELATIONSHIP,
  // REVIEW_MANAGE_GRID_COLUMN_ID.IDENTIFIED_FOR_CALIBRATION, // this one is not applicable on review manage page
  REVIEW_MANAGE_GRID_COLUMN_ID.REVIEW_STATUS,
  REVIEW_MANAGE_GRID_COLUMN_ID.SELF_REVIEW_STATUS,
  REVIEW_MANAGE_GRID_COLUMN_ID.MANAGER,
  REVIEW_MANAGE_GRID_COLUMN_ID.MANAGER_REVIEW_STATUS,

  REVIEW_MANAGE_GRID_COLUMN_ID.DLM_NOMINATED,
  REVIEW_MANAGE_GRID_COLUMN_ID.DLM_REVIEW_STATUS,

  REVIEW_MANAGE_GRID_COLUMN_ID.PEER_NOMINATED,
  REVIEW_MANAGE_GRID_COLUMN_ID.PEER_REVIEW_STATUS,

  REVIEW_MANAGE_GRID_COLUMN_ID.UPWARD_REVIEW_STATUS,

  REVIEW_MANAGE_GRID_COLUMN_ID.EMAIL,
  REVIEW_MANAGE_GRID_COLUMN_ID.MANAGER_EMAIL,

  REVIEW_MANAGE_GRID_COLUMN_ID.GENDER,
  REVIEW_MANAGE_GRID_COLUMN_ID.LOCATION,
  REVIEW_MANAGE_GRID_COLUMN_ID.FUNCTION,
  REVIEW_MANAGE_GRID_COLUMN_ID.EXTERNAL_EMP_ID,
  REVIEW_MANAGE_GRID_COLUMN_ID.ETHNICITY,
  REVIEW_MANAGE_GRID_COLUMN_ID.DATE_OF_JOINING,
  REVIEW_MANAGE_GRID_COLUMN_ID.DOB,
  REVIEW_MANAGE_GRID_COLUMN_ID.COUNTRY,
  REVIEW_MANAGE_GRID_COLUMN_ID.DESIGNATION,
  REVIEW_MANAGE_GRID_COLUMN_ID.ROLE,
  REVIEW_MANAGE_GRID_COLUMN_ID.GRADE,
  REVIEW_MANAGE_GRID_COLUMN_ID.DEPARTMENT,
  REVIEW_MANAGE_GRID_COLUMN_ID.COMPANY,
  REVIEW_MANAGE_GRID_COLUMN_ID.SUPER_POD,
  REVIEW_MANAGE_GRID_COLUMN_ID.POD,

  REVIEW_MANAGE_GRID_COLUMN_ID.GRID_POSITION,
  REVIEW_MANAGE_GRID_COLUMN_ID.OUTCOME,
  REVIEW_MANAGE_GRID_COLUMN_ID.LAST_COMMENT,

  REVIEW_MANAGE_GRID_COLUMN_ID.OVERALL_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.OVERALL_NUMERIC_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.GOAL_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.GOAL_NUMERIC_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.COMPETENCY_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.COMPETENCY_NUMERIC_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.QNA_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.QNA_NUMERIC_RATING,

  REVIEW_MANAGE_GRID_COLUMN_ID.SELF_OVERALL_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.SELF_GOAL_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.SELF_COMPETENCY_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.SELF_QNA_RATING,

  REVIEW_MANAGE_GRID_COLUMN_ID.MANAGER_OVERALL_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.MANAGER_OVERALL_NUMERIC_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.MANAGER_GOAL_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.MANAGER_GOAL_NUMERIC_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.MANAGER_COMPETENCY_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.MANAGER_COMPETENCY_NUMERIC_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.MANAGER_QNA_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.MANAGER_QNA_NUMERIC_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.MANAGER_OUTCOME,

  REVIEW_MANAGE_GRID_COLUMN_ID.DLM_OVERALL_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.DLM_GOAL_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.DLM_COMPETENCY_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.DLM_QNA_RATING,

  REVIEW_MANAGE_GRID_COLUMN_ID.PEER_OVERALL_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.UPWARD_OVERALL_RATING,
];

export const REVIEWS_CALIBRATE_PAGE_DEFAULT_COLUMN_ORDER = [
  REVIEW_MANAGE_GRID_COLUMN_ID.EMPLOYEE,
  REVIEW_MANAGE_GRID_COLUMN_ID.RELATIONSHIP,
  REVIEW_MANAGE_GRID_COLUMN_ID.IDENTIFIED_FOR_CALIBRATION,
  REVIEW_MANAGE_GRID_COLUMN_ID.REVIEW_STATUS,
  REVIEW_MANAGE_GRID_COLUMN_ID.CALIBRATION_STATUS,

  REVIEW_MANAGE_GRID_COLUMN_ID.OVERALL_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.OVERALL_NUMERIC_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.OUTCOME,
  REVIEW_MANAGE_GRID_COLUMN_ID.GRID_POSITION,
  REVIEW_MANAGE_GRID_COLUMN_ID.LAST_COMMENT,
  REVIEW_MANAGE_GRID_COLUMN_ID.GOAL_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.GOAL_NUMERIC_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.COMPETENCY_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.COMPETENCY_NUMERIC_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.QNA_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.QNA_NUMERIC_RATING,

  REVIEW_MANAGE_GRID_COLUMN_ID.MANAGER,
  REVIEW_MANAGE_GRID_COLUMN_ID.MANAGER_REVIEW_STATUS,
  REVIEW_MANAGE_GRID_COLUMN_ID.MANAGER_OVERALL_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.MANAGER_OVERALL_NUMERIC_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.MANAGER_GOAL_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.MANAGER_GOAL_NUMERIC_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.MANAGER_COMPETENCY_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.MANAGER_COMPETENCY_NUMERIC_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.MANAGER_QNA_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.MANAGER_QNA_NUMERIC_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.MANAGER_OUTCOME,

  REVIEW_MANAGE_GRID_COLUMN_ID.SELF_REVIEW_STATUS,
  REVIEW_MANAGE_GRID_COLUMN_ID.SELF_OVERALL_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.SELF_GOAL_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.SELF_COMPETENCY_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.SELF_QNA_RATING,

  REVIEW_MANAGE_GRID_COLUMN_ID.DLM_NOMINATED,
  REVIEW_MANAGE_GRID_COLUMN_ID.DLM_REVIEW_STATUS,
  REVIEW_MANAGE_GRID_COLUMN_ID.DLM_OVERALL_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.DLM_GOAL_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.DLM_COMPETENCY_RATING,
  REVIEW_MANAGE_GRID_COLUMN_ID.DLM_QNA_RATING,

  REVIEW_MANAGE_GRID_COLUMN_ID.UPWARD_REVIEW_STATUS,
  REVIEW_MANAGE_GRID_COLUMN_ID.UPWARD_OVERALL_RATING,

  REVIEW_MANAGE_GRID_COLUMN_ID.PEER_NOMINATED,
  REVIEW_MANAGE_GRID_COLUMN_ID.PEER_REVIEW_STATUS,
  REVIEW_MANAGE_GRID_COLUMN_ID.PEER_OVERALL_RATING,

  REVIEW_MANAGE_GRID_COLUMN_ID.EMAIL,
  REVIEW_MANAGE_GRID_COLUMN_ID.MANAGER_EMAIL,
  REVIEW_MANAGE_GRID_COLUMN_ID.GENDER,
  REVIEW_MANAGE_GRID_COLUMN_ID.LOCATION,
  REVIEW_MANAGE_GRID_COLUMN_ID.FUNCTION,
  REVIEW_MANAGE_GRID_COLUMN_ID.EXTERNAL_EMP_ID,
  REVIEW_MANAGE_GRID_COLUMN_ID.ETHNICITY,
  REVIEW_MANAGE_GRID_COLUMN_ID.DATE_OF_JOINING,
  REVIEW_MANAGE_GRID_COLUMN_ID.DOB,
  REVIEW_MANAGE_GRID_COLUMN_ID.COUNTRY,
  REVIEW_MANAGE_GRID_COLUMN_ID.DESIGNATION,
  REVIEW_MANAGE_GRID_COLUMN_ID.ROLE,
  REVIEW_MANAGE_GRID_COLUMN_ID.GRADE,
  REVIEW_MANAGE_GRID_COLUMN_ID.DEPARTMENT,
  REVIEW_MANAGE_GRID_COLUMN_ID.COMPANY,
  REVIEW_MANAGE_GRID_COLUMN_ID.SUPER_POD,
  REVIEW_MANAGE_GRID_COLUMN_ID.POD,
];
